import { makeStyles, Text } from '@rneui/themed'
import { font } from 'app/theme'
import { t } from 'app/i18l'
import React from 'react'
import { View } from 'react-native'
import { ShiftAmountExplanationMessageView } from './shift_amount_explanation_message'

interface Props {
  amount?: number
  bonus?: number
  shiftAmountExplanationMessage?: string
}

export function ShiftPayView(props: Props) {
  const styles = useStyles()

  if (props.amount === undefined) {
    return null
  }

  const dollars = Math.floor(props.amount)
  const cents = Math.round((props.amount - dollars) * 100)
  const dollarsString = String(dollars)
  const centsString = (cents < 10 ? '0' : '') + String(cents)

  return (
    <View style={styles.container}>
      <Text style={styles.dollarAmountSuperscript}>$</Text>
      <Text style={styles.dollarAmount}>{dollarsString}</Text>
      <Text style={styles.dollarAmountSuperscript}>{centsString}</Text>
      {props.bonus ? (
        <Text style={styles.bonusText}>
          {' '}
          + ${props.bonus} {t('shiftBonus')}
        </Text>
      ) : null}
      {props.shiftAmountExplanationMessage ? (
        <Text style={styles.payExplanationText}>
          <ShiftAmountExplanationMessageView
            message={props.shiftAmountExplanationMessage}
          />
        </Text>
      ) : null}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  dollarAmount: {
    fontSize: 18,
    fontFamily: font.bold,
    lineHeight: 20,
    color: theme.colors?.primary,
  },
  dollarAmountSuperscript: {
    fontSize: 14,
    fontFamily: font.bold,
    lineHeight: 14,
    color: theme.colors?.primary,
  },
  bonusText: {
    fontSize: 15,
    fontFamily: font.normal,
    color: theme.colors?.primary,
  },
  payExplanationText: {
    marginLeft: 20,
    lineHeight: 20,
  },
}))
